export default __webpack_public_path__ + "static/ao-d31d84f23db14f80ec2dde305c0abedd.svg";